module.exports = __webpack_public_path__ + "static/media/seaborn.95fde664.png";